/**
 * !!! Shouldn't be used directly. Is used by integrationAPI.
 */

import isEmpty from 'lodash/isEmpty'
import { getProductFromDict } from './productsDict'

const getProductInfo = (p, productsDict = {}) => {
  if (isEmpty(productsDict)) {
    return p
  } else {
    const res = getProductFromDict(p, productsDict)
    if (res) {
      return res
    } else {
      return p
    }
  }
}

const dummyAPI = {
  getProductInfo: getProductInfo,
  addToCart: () => null,
  getProductPrice: (product, sOptions) => product.details.price,
  getProductPrevPrice: (product, sOptions) => product.details.prevPrice,
  cancel: () => null,
  getCart: () => null,
  setOnChangeCart: () => null,
  deleteFromCart: () => null,
  getDisabledOptions: (product, seletedOptions) => {},
  getAvailableOptions: (p, v) => v,
  clearCart: () => null,
  deleteCartHistory: () => null,
  availableProducts: () => [],
  isInitialized: () => true,
  refreshProducts: () => null
}

export default dummyAPI



// WEBPACK FOOTER //
// ./src/api/dummyAPI.js